import React from 'react';
import './AccessGuardOverlay.css';

/**
 * Full-screen overlay shown when the current session becomes invalid
 * (user deactivated OR school subscription inactive).
 *
 * Uses unique classnames to avoid style conflicts.
 */
const AccessGuardOverlay = ({ title, message, onAcknowledge }) => {
  return (
    <div className="mds-access-guard__overlay" role="alertdialog" aria-live="assertive" aria-modal="true">
      <div className="mds-access-guard__card">
        <div className="mds-access-guard__icon" aria-hidden="true">!</div>
        <div className="mds-access-guard__content">
          <h2 className="mds-access-guard__title">{title || 'Access blocked'}</h2>
          <p className="mds-access-guard__message">
            {message || 'Your access is no longer available. Click “I understand” to return to the home page.'}
          </p>
          <div className="mds-access-guard__actions">
            <button
              type="button"
              className="mds-access-guard__primary-btn"
              onClick={() => {
                if (typeof onAcknowledge === 'function') {
                  onAcknowledge();
                } else {
                  window.location.href = '/';
                }
              }}
            >
              I understand
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessGuardOverlay;


